import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations } from '../data/translations';
export type Language = 'es' | 'en' | 'fr' | 'pl' | 'de';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [language, setLanguage] = useState<Language>('es');
  const t = (key: string): string => {
    // @ts-ignore
    return translations[language][key] || translations['es'][key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-577" data-mp="32tpodb1w06rd">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};